<template>
  <FilterBadge v-bind="{ ...$props, ...$attrs }">
    {{ text }}
  </FilterBadge>
</template>

<script setup lang="ts">
import { computed, type PropType } from "vue";
import { useTranslation } from "@/language/translation";
import RecentlyChangedFilter from "../../filterImplementations/RecentlyChangedFilter";
import FilterBadge from "./FilterBadge.vue";

const props = defineProps({
  filter: {
    type: Object as PropType<RecentlyChangedFilter>,
    required: true,
  },
});
const { t } = useTranslation();
const text = computed(() => {
  const hours = props.filter.definitionOfRecentInHours;
  if (hours % 24 === 0) {
    return `${t("components.eventAction.filter.ui.RecentlyChanged.textShort")}: ${hours / 24} ${t(
      "components.eventAction.filter.ui.RecentlyChanged.days",
      { count: Math.round((hours / 24) * 1000) / 1000 },
    )}`;
  }
  return `${t("components.eventAction.filter.ui.RecentlyChanged.textShort")}: ${
    Math.round(hours * 1000) / 1000
  } ${t("components.eventAction.filter.ui.RecentlyChanged.hours", {
    count: Math.round(hours * 1000) / 1000,
  })}`;
});
</script>

<style lang="scss" scoped></style>
